<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">{{
          $t("users.users")
        }}</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td>id</td>
                <td>{{ usersingle.id }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.first_name") }}</td>
                <td>{{ usersingle.first_name }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.last_name") }}</td>
                <td>{{ usersingle.last_name }}</td>
              </tr>

              <tr>
                <td>{{ $t("users.gender") }}</td>
                <td v-if="usersingle.gender === '1'">{{ $t("users.mr") }}</td>
                <td v-if="usersingle.gender === '2'">{{ $t("users.mrs") }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.name") }}</td>
                <td>{{ usersingle.name }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.function") }}</td>
                <td>{{ usersingle.function }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ usersingle.email }}</td>
              </tr>
              <tr>
                <td>team_id</td>
                <td>{{ usersingle.team_id }}</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>{{ usersingle.type }}</td>
              </tr>
              <tr>
                <td>Admin</td>
                <td>{{ usersingle.is_admin }}</td>
              </tr>
              <tr>
                <td>SuperUser</td>
                <td>{{ usersingle.is_superuser }}</td>
              </tr>
              <tr>
                <td>PCM</td>
                <td>{{ usersingle.has_pcm }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.famchart") }}</td>
                <td>{{ usersingle.has_famchart }}</td>
              </tr>
              <tr>
                <td>Exit planning</td>
                <td>{{ usersingle.has_exitplan }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent">
            {{ $t("crud.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
export default {
  name: "userview",
  components: { ToolbarAuth, Navigation },
  data() {
    return {
      email: "",
      search: "",
      headers: [
        {
          text: this.$t("users.users"),
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "EMAIL", sortable: true, value: "email" },
        { text: this.$t("crud.actions"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    closeView() {
      this.$router.push({ name: "usersIndex" });
    },
  },
  computed: {
    ...mapGetters("usersingle", ["loading", "error", "usersingle"]),
  },
  created() {
    let UserId = this.$route.params.id;
    this.$store.dispatch("usersingle/getUser", UserId);
  },
};
</script>

<style scoped></style>
